<app-statistics grapType="capability"></app-statistics>